import React, { Component } from "react";
import PaySelect from "Molecules/PaySelect";
import Policies from "Molecules/Policies";
import Caret from "Atoms/Caret";
import AccountNumber from "Atoms/AccountNumber";
import ReadOnlyPrice from "Atoms/ReadOnlyPrice";
import TextField from "Atoms/TextField";
import Currency from 'react-currency-formatter';
import moment from 'moment';
import Tag from "../../atoms/Tag/Tag";
import * as _ from "lodash";




export default class AccountItem extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isPaySelectOpen: false,
			classes: "billing-accounts-item",
			openType: null,        
  			openPolicyIndex: null,
			policyId: null
		};
		this.togglePaySelect = this.togglePaySelect.bind(this);
		this.togglePaySelectPolicy = this.togglePaySelectPolicy.bind(this);
		this.closePaySelect = this.closePaySelect.bind(this);

	}

togglePaySelect = () => {
	if (this.state.isPaySelectOpen && this.state.openType === "billing") {
		this.props.hidePayVeil();
		this.setState({
		classes: "billing-accounts-item",
		isPaySelectOpen: false,
		openType: null,
		openPolicyIndex: null
	});

  } else {
	this.props.showPayVeil();
	this.setState({
	classes: this.state.classes + " payselect-is-visible",
	isPaySelectOpen: true,
      openType: "billing",
	  openPolicyIndex: null
    });
  }
};

	togglePaySelectPolicy = (index, pnum) => { 
		if (
			this.state.isPaySelectOpen &&
			this.state.openType === "policy" &&
			this.state.openPolicyIndex === index
		) { 
			this.props.hidePayVeil();
			this.setState({
				classes: "policy-accounts-item",
				isPaySelectOpen: false,
				openType: null,
				openPolicyIndex: null,
				policyId: pnum
		});
		} else { 
			this.props.showPayVeil();
				this.setState({
				classes: this.state.classes + " payselect-is-visible",
				isPaySelectOpen: true,
				openType: "policy",
				openPolicyIndex: index,
				policyId: pnum
			});
}

};


	paySelectKeyUpToggle = event => {
		if (event.keyCode === 13) {
			this.togglePaySelect();
		} else if (event.keyCode === 27) {
			this.props.hidePayVeil();
			this.setState({
				classes: "billing-accounts-item",
				isPaySelectOpen: false
			});
		}
	}

	closePaySelect(){
		this.setState({
			isPaySelectOpen: false,
			classes: "billing-accounts-item payselect-is-visible",
			openType: null,        
  			openPolicyIndex: null,
		});
		this.props.hidePayVeil();
	}

	openPayModalKeyUp(e) {
		if (e.keyCode === 13) {
      this.props.openPayModal(this.props.accountData.account_number);
		}
	}

	renderMessages = (reoccuringPaymentIndicator,minimum_due_date,finalDate,pastDueIncludedIndicator) =>{
		

		if ((minimum_due_date == null) && !reoccuringPaymentIndicator){
			return (
				<div className="payment-due-date">
				  Minimum Due
				</div>
			)
		}


  		else if (reoccuringPaymentIndicator && !pastDueIncludedIndicator){
			return (
				<div className="payment-due-date">
						Autopay enabled
				</div>
			)
		}
		else if (reoccuringPaymentIndicator && pastDueIncludedIndicator){
			return (
				<div className="payment-additional-info">
					Autopay failed, please contact support
				</div>
			)
		}
		else {
			return (
				<div className="payment-due-date">
					{`Minimum due by ${finalDate}`}
				</div>
			)
		}
	}
	check = (conditions) => {
		return (conditions)	? true : false;
	
	}

	checkPastDueIncluded = (pastDueIncludedIndicator,payment_amount) => {
		return pastDueIncludedIndicator && payment_amount>0;
	}
	renderPaymentInfoMessage = () => {
		let { minimum_due_amount, past_due_amount, recurring_enabled, paymentOption, minimum_due_date } = this.props.accountData;
		//check for reoccuring payments
		let reoccuringPaymentIndicator = this.check(recurring_enabled);

		//check if there is a past due amount
		let pastDueIncludedIndicator = this.check(past_due_amount > 0);
		let finalDate;

		if(minimum_due_date != null){
			//TIME CODE: https://stackoverflow.com/questions/36206260/how-to-set-date-always-to-eastern-time-regardless-of-users-time-zone
			let dateArray = minimum_due_date.split(/[^0-9]/);
			let dueDate = new Date(dateArray[0], dateArray[1] - 1 , dateArray[2]);
			finalDate = moment(dueDate).format('MMM DD, YYYY');
		}
		if(paymentOption && paymentOption !== "min"){
			let {payment_amount}=this.props.accountData;
			return (
				<div>
					<div className="payment-due-date">
						{paymentOption}
					</div>
					{this.checkPastDueIncluded(pastDueIncludedIndicator, payment_amount) && <div className="payment-additional-info">Past due included</div>}
				</div>
			)
		}

		if ((minimum_due_date !== null) && !reoccuringPaymentIndicator && (past_due_amount > 0)){
				return (
				<div>
					<div className="payment-due-date">
						{`Minimum due by ${finalDate}`}
					</div>

					<div className="payment-additional-info">
						Past due included
					</div>
					</div>
				)
			}
			if(minimum_due_amount === 0 && !reoccuringPaymentIndicator){
				return (
					<div className="payment-due-date"></div>
				)
			}

		return this.renderMessages(reoccuringPaymentIndicator,minimum_due_date,finalDate,pastDueIncludedIndicator);

	}



	handleAccountNumberClick = () => {
		this.props.openPayModal(this.props.accountData.account_number);
	}

	handlePolicyNumberClick = () => {
		const policyId = this.props.accountData.policies.findIndex(
			policy => policy.policy_number === this.props.accountData.policies.policy_number
		);
		this.props.openPolicyPayModal(this.props.accountData.policies[policyId].policy_number);
	}

	checkCancelled = (policies) => {
		if(policies===undefined){
			return false;
		  }
		const cancelledPolicies = policies.filter(el => {
			if(el.policy_status!==null && el.policy_status!==undefined){
				return el.policy_status.toLowerCase().includes("cancellation pending");
			}
			return false;
		});
		return cancelledPolicies.length>0;
	}

	render() {
		let {
			mobileViewToggle, index,
			accountData: {product_code,policies,payment_amount,account_number,minimum_due_amount,pay_in_full_amount,past_due_amount,recurring_enabled}
		 } = this.props;
		 
		 _.forEach(this.props.accountData.policies, policy => {
			 if (policy.paymentOption) {
				 if (policy.paymentOption === 'Other amount' && policy.policy_amount > 0) {
					 policy.summaryPolicyData = policy.policy_amount;
					
				 } else if (policy.paymentOption === 'min' && policy.min_due > 0) {
					 policy.summaryPolicyData = policy.min_due;
					
				 } else if (policy.paymentOption === 'Full payment' && policy.total_due > 0) {
					 policy.summaryPolicyData = policy.total_due;
					
				 }
				 else if (policy.paymentOption === 'No payment') {
					 policy.summaryPolicyData = policy.policy_amount;
			 }
			 } else {
			 	 if (policy.min_due > 0 && !policy.paymentOption) {
			 		 policy.summaryPolicyData = policy.min_due;
		 	 } else {
					 policy.summaryPolicyData = 0;
		 }
		 	}
		 });
		let summaryAccountData = minimum_due_amount;

		if(payment_amount >= 0){
			summaryAccountData = payment_amount;
		} else if(recurring_enabled && past_due_amount > 0){
			summaryAccountData = minimum_due_amount;
		} else if((recurring_enabled && past_due_amount === 0)){
			summaryAccountData = 0;
		}
		const containsCancelledPolicies=this.checkCancelled(policies);
		return (
			<div className={this.state.classes}>
				<div className="paysummary">
					<div className="dx-col">
						<div className="group">
							<div className="row account">
								<div className="dx-col" onClick={this.handleAccountNumberClick} onKeyUp={(e)=>{this.openPayModalKeyUp(e)}}>
									<a className={`goto-details`} id={`details-${index}`} onClick={this.handleAccountNumberClick}><Caret /></a>
									<div className="label">
										{" "}Billing Account{" "}
									</div>
									<div style={{"display": "flex","alignItems": "center"}}>
										<div aria-label="Billing Account Number" className={`content accNumInfo${account_number}`} tabIndex="0">
											{" "} <AccountNumber accountNumber={account_number} />{" "}
										</div>
										{product_code==="RSCIA" &&<Tag text={"RSCIA"}/>}
										{containsCancelledPolicies && <Tag text={"Cancellation Pending"}/>}
									</div>
								</div>
							</div>
							<div
								onClick={this.togglePaySelect}
								className="payselect-trigger"
								tabIndex="0"
								onKeyUp={this.paySelectKeyUpToggle}>
								<span className="Caret" >
									<svg
										width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
										<path d="M16.333 13.667L9.667 7 3 13.667z" strokeWidth="2" fillRule="evenodd"/>
									</svg>
								</span>
							</div>
							{this.state.isPaySelectOpen &&
								this.state.openType === "billing" && (
								<PaySelect
									mode="billing"
									billingId={account_number}
									account={this.props.accountData}
									closeHandler={this.closePaySelect}
									entityContext = {{ type: "billing", billingId: account_number, policyId: null}}	
								/>
							)}

							{/* <Policies policies={policies} showAmount={mobileViewToggle} /> */}
						</div>
						<div className="group">
							<div className="row total">
								<div className="dx-col">
									<div className="payment-total is-readonly">
										<div className="element readonly">
											<span> <Currency quantity={summaryAccountData} pattern="!#,##0.00" /></span>
										</div>
										<div className="element editable">
											<div className="element readonly">
												<span>
													<ReadOnlyPrice price={"2000"} />
												</span>
											</div>

											<TextField placeholder="Full Amount" id="billing" maskType="dollars" value={pay_in_full_amount} />
										</div>
									</div>


									{ this.renderPaymentInfoMessage() }


								</div>
							</div>
						</div>
					</div>
					{/* <div className="area-header">
						{" "}Policy Account{" "}
					</div> */}
					{policies.map((policy, index) => (
					<div style={{paddingLeft: '24px'}} className="dx-col" key={policy.policy_number}>
						<div className="group">
								<div className="row account">
									<div className="dx-col" onKeyUp={(e)=>{this.openPayModalKeyUp(e)}}>
										<a className={`showPolicy`}
											onClick={() => this.togglePaySelectPolicy(index, policy.policy_number)} id={`details-${index}`} ><Caret /></a>

										<div  key={index} aria-label="Policy Account Number" className={`content accNumInfo${policy.policy_number}`} tabIndex="0" style={{"display": "flex","alignItems": "center"}}>
											<Policies policies={policies} showAmount={mobileViewToggle} />

											<div aria-label="Policy Account Number" className={`content accNumInfo${policy.policy_number}`} tabIndex="0">
												{" "} {policy.policy_number}{" "}
											</div>
											{policy.policy_type==="RSCIA" &&<Tag text={"RSCIA"}/>}
											{policy.term && <Tag text={policy.term}/>}
										</div>
									</div>
								</div>
								
						</div>

						<div className="group">
							<div className="row total">
								<div className="dx-col">
									<div
						onClick={()=>this.togglePaySelectPolicy(index, policy.policy_number)}
						className="policyBox"
						tabIndex="0"
						onKeyUp={()=>this.paySelectKeyUpToggle}>
						<span className="Caret" >
							<svg
								width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
								<path d="M16.333 13.667L9.667 7 3 13.667z" strokeWidth="2" fillRule="evenodd"/>
							</svg>
						</span>
					</div>
						<div className="policyPopup">
							{this.state.isPaySelectOpen &&
								this.state.openType === "policy" &&
								this.state.openPolicyIndex === index && (
								<PaySelect
									mode="policy"
									policyId={policy.policy_number}
									policy={policy}
									account={this.props.accountData}
									entityContext = {{ type: "policy", billingId: null, policyId: policy.policy_number}} 
									closeHandler={this.closePaySelect}
								/>
							)}
						</div>
					
									<div className="payment-total is-readonly">
										<div className="element readonly">
												<span> <Currency quantity={policy.summaryPolicyData} pattern="!#,##0.00" /></span>
										</div>																		   
										<div className="element editable">
											<div className="element readonly">
												<span>
													<ReadOnlyPrice price={"2000"} />
												</span>
											</div>

											{/* <TextField placeholder="Full Amount" id="billing" maskType="dollars" value={combinedPolicies.minDues} /> */}
										</div>
									</div>
									{ this.renderPaymentInfoMessage() }


								</div>
							</div>
						</div>
					</div>))}
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/atomic/molecules/AccountItem/AccountItem.js